import { createAction, createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/parametros';

function validarParametros(state, action) {
  const { responseParametros, nombreLista } = action.payload;
  state.response[nombreLista] = responseParametros;
  state.responseError = false;
}


function validarParametrosError(state) {
  state.response = [];
  state.responseError = true;
}


const parametrosServicio = createAction('parametrosServicio');


const parametrosReducer = createSlice({
  name: 'parametros',
  initialState: initState,
  reducers: {
    validarParametros,
    validarParametrosError,
  },
});

export const parametrosActions = {
  ...parametrosReducer.actions,
  parametrosServicio,
};

export default parametrosReducer.reducer;
